
import * as d3 from 'd3'
export default {
  methods: {

    coverSVG(blk_) {
      let x_ = 10
      let cover = this.svg
      .append('g')
      .attr('transform', `translate(15, 290)`)

      cover
      .append('rect')
      .attr('x', 0).attr('y', 8)
      .attr('width', 400).attr('height', 25)
      .attr('fill', '#000').attr('opacity', .3)

      cover
      .append('text')
      .attr('id', `BLK_${this.localId}`)
      .attr('transform', `translate(${x_}, 25)`)
      .attr('font-size', 15).attr('fill', '#333')
      .text(blk_.ER_BK)

      x_ = x_ + this.getNode(`#BLK_${this.localId}`, 'width') + 5
      cover
      .append('text')
      .attr('id', `WT_${this.localId}`)
      .attr('x', x_).attr('y', 25)
      .attr('font-size', 10).attr('fill', '#444')
      .text(`${blk_.WT} (mt)`)

      x_ = 200
      cover
      .append('text')
      .attr('id', `PLAN_${this.localId}`)
      .attr('x', x_).attr('y', 25)
      .attr('font-size', 12).attr('fill', '#ffff')
      .text(blk_.PSD)

      x_ = x_ + this.getNode(`#PLAN_${this.localId}`, 'width') + 5
      cover
      .append('text')
      .attr('id', `DASH_${this.localId}`)
      .attr('x', x_).attr('y', 25)
      .attr('font-size', 12).attr('fill', '#333')
      .text('/')

      x_ = x_ + this.getNode(`#DASH_${this.localId}`, 'width') + 5
      cover
      .append('text')
      .attr('id', `ACT_${this.localId}`)
      .attr('x', x_).attr('y', 25)
      .attr('font-size', (blk_.ASD) ? 12 : 11)
      .attr('fill', (blk_.ASD) ? '#fff' : '#333')
      .text(()=> {
        if(blk_.ASD) return blk_.ASD
        else return `${this.gmx_dateDiff(blk_.PSD, this.cutoff)} days to go until planned date`
      })
    }

  }
}